import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MapLoadingService } from './map-loading.service';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport,
  withXhr,
} from '@angular/common/http';

/** @deprecated */
export function provideMapLoadingService(): EnvironmentProviders {
  return makeEnvironmentProviders([
    MapLoadingService,
    provideHttpClient(withXhr(), withJsonpSupport(), withInterceptorsFromDi()),
  ]);
}
